import {
	PROGRAM_COLOR_CLASSES,
	normalizeProgramColor,
	programColorLabelKey,
} from "../../lib/programColors";
import { useLanguage } from "../../contexts/LanguageContext";

/**
 * Il colore di un programma, reso in due forme sole, cosi' si legge allo stesso
 * modo ovunque (lista programmi, blocco «Oggi», selettori di programma):
 *
 * - `ProgramColorDot`: un pallino in linea col nome;
 * - `ProgramColorStripe`: una barra verticale sul bordo sinistro di una card
 *   (il genitore e' `relative overflow-hidden`).
 *
 * Entrambi hanno il nome del colore come testo alternativo e come `title`, e
 * non rendono nulla senza colore: un programma senza etichetta e' identico a
 * prima. Spec: docs/program-colors/01-analisi.md.
 */

export function ProgramColorDot({ color, className = "" }) {
	const { t } = useLanguage();
	const key = normalizeProgramColor(color);
	if (!key) return null;
	const label = t(programColorLabelKey(key));
	return (
		<span
			role="img"
			aria-label={label}
			title={label}
			data-testid="program-color-dot"
			className={`inline-block w-2.5 h-2.5 rounded-full shrink-0 ${PROGRAM_COLOR_CLASSES[key].bg} ${className}`}
		/>
	);
}

export function ProgramColorStripe({ color }) {
	const { t } = useLanguage();
	const key = normalizeProgramColor(color);
	if (!key) return null;
	const label = t(programColorLabelKey(key));
	return (
		<span
			role="img"
			aria-label={label}
			title={label}
			data-testid="program-color-stripe"
			className={`absolute inset-y-0 left-0 w-1 ${PROGRAM_COLOR_CLASSES[key].bg}`}
		/>
	);
}
